import { Fragment } from 'react';

import useOmeMeets from './UseOmeMeets';

import Views from '../HostRegistrationViews';
import ViewTemplate from '../../../../components/viewTemplate/ViewTemplate';

import OmeMeetsGrid from './OmeMeetsGrid';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const OmeMeets = () => {
  const {
    state,
    omeMeetEntryState,
    modalState,
    onModalCanceled,
    onAddOmeMeet,
    onEditOmeMeet,
    onDeleteOmeMeetClicked,
    onDeleteOmeMeet,
    onNextButtonClicked,
    onBackButtonClicked,
    onSaveAndExitButtonClicked,
    allowEdits
  } = useOmeMeets();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_OME_MEETS}
        onNextButtonClicked={onNextButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        errorMessage={state.error}>
        <Fragment>
          {allowEdits() === true ?
            <div className='row'>
              <div className='col-xs-12 col-sm-6'>
                <ActionIntraPageButton onClick={onAddOmeMeet}>Add Additional OME Meet</ActionIntraPageButton>
              </div>
              {omeMeetEntryState.objData.omeMeetEntry?.length > 0 && omeMeetEntryState.objData.omeMeetEntry[0]?.timeZone &&
                <div className='col-xs-12 col-sm-6 visible-md visible-lg'>
                  <p className='pull-right'>Time Zone: {omeMeetEntryState.objData.omeMeetEntry[0]?.timeZone || ''}</p>
                </div>}
            </div> :
            <Fragment>
              {omeMeetEntryState.objData.omeMeetEntry?.length > 0 && omeMeetEntryState.objData.omeMeetEntry[0]?.timeZone &&
                <div className='row'>
                  <div className='col-xs-12  visible-md visible-lg'>
                    <p className='pull-right'>Time Zone: {omeMeetEntryState.objData.omeMeetEntry[0]?.timeZone || ''}</p>
                  </div>
                </div>}
            </Fragment>
          }
          <OmeMeetsGrid
            state={omeMeetEntryState}
            onEdit={onEditOmeMeet}
            onDelete={onDeleteOmeMeetClicked}
          />
        </Fragment>
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={modalState.modalTitle}
          displayPopUp={modalState.displayPopUp}
          onModalCanceled={onModalCanceled}>
          <div className="row">
            <div className="col-xs-12">
              <p><b>OME Meet Name:</b>&nbsp;{modalState.omeMeetName}</p>
              <p><b>Entry Start Date:</b>&nbsp;{modalState.meetEntryStartDate}</p>
              <p><b>Entry End Date:</b>&nbsp;{modalState.meetEntryEndDate}</p>
              <p><b>Time Zone:</b>&nbsp;{modalState.timeZone}</p>
              <p><b>Status:</b>&nbsp;{modalState.status}</p>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
              <PrimaryButton type="button" onClick={(e) => onDeleteOmeMeet(e, modalState.omeMeetEntryId)}>Delete</PrimaryButton>
            </div>
          </div>
        </PopUpModal>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetEntryState.isObjLoading} />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={omeMeetEntryState.isSaving} />
      </ViewTemplate>
    </Fragment>
  );
};

export default OmeMeets;